import React, {useState} from "react";
import {deliveriesService, userServices} from "../../services";
import {notification} from "antd";
import moment from "moment";
import {
  DELIVERY_AWAITING_LOADING,
  DELIVERY_BOOKED,
  DELIVERY_ORDER_FILLED,
  DELIVERY_LOADING, DELIVERY_RESERVED, DELIVERY_ORDER_APPROVED,
  DELIVERY_IN_TENDER,
  DELIVERY_FREE
} from "../../helpers/delivery_status.helper";
import ModalRefuseDelivery from "../modals/refuse-delivery";
import {DeliveryHistoryButton} from "./delivery-history-button";
import {CREATE_DELIVERY} from "../../helpers/user_permission.helper";
import ModalChangeLoadingDate from "../modals/change-loading-date";
import { AUCTION_MULTIMODAL_TYPE, DELIVERY_DEFAULT_TYPE } from "../../helpers/delivery.helper";
import CreateDeliveryModal from "../modals/create-delivery";
import ModalEditDelivery from "../modals/edit-delivery";
import i18n from "../../i18n";

export function LogistFullButton({
                                   delivery,
                                   permissions,
                                   setNeedUpdate,
                                   setStopListUpdate,
                                   setLoadingDelivItem,
                                   timerEnabled
                                 }) {
  const user = userServices.getUser();

  if (typeof (delivery.Permissions) == "undefined") {
    return null;
  }
  if (delivery.Permissions.IsAvailableManageDelivery === false) {
    return null;
  }

  const [showRefuseDeliveryModal, setShowRefuseDeliveryModal] = useState(false);
  const [showChangeLoadingDateModal, setShowChangeLoadingDateModal] = useState(false);
  const [showTenderToDeliveryModal, setShowTenderToDeliveryModal] = useState(false);
  const [showEditDeliveryModal, setShowEditDeliveryModal] = useState(false);

  const isCanRefuse = (delivery.Permissions) ? delivery.Permissions.IsAvailableRefuseDelivery && !delivery.Permissions.IsAccessCreatedOrder && !delivery.Permissions.IsAvailableAgreeWithoutDocs : false;

  const onCLickShowRefuseModal = (e) => {
    e.preventDefault();
    setStopListUpdate(true);
    setShowRefuseDeliveryModal(true);
  };

  const onClickShowTenderToDeliveryModal = (e) => {
    e.preventDefault();
    setStopListUpdate(true);
    setShowTenderToDeliveryModal(true);
  }

  let btnReservation;
  let btnRefuseDelivery;
  let btnCancelReserve;
  let btnChangeDateLoading;
  let btnDeliveryHistory = (
    <DeliveryHistoryButton delivery={delivery}/>
  );
  let btnCreateAnalogueDelivery = null;

  if (user.isAccessTo(CREATE_DELIVERY) && delivery.Type === DELIVERY_DEFAULT_TYPE) {
    btnCreateAnalogueDelivery = (
      <a className="action-button typical-btn-blue" href={`/consignor/create-delivery?deliveryID=${delivery.Id}`}>
        {i18n.t('components.tools.logistFullButton.buttons.createDelivery')}
      </a>
    );
  }

  if (user.isAccessTo(CREATE_DELIVERY) && delivery.Status === DELIVERY_IN_TENDER && delivery.Type !== AUCTION_MULTIMODAL_TYPE) {
    btnCreateAnalogueDelivery = (
      <>
        <a className="action-button typical-btn-blue" onClick={onClickShowTenderToDeliveryModal}>
          {i18n.t('components.tools.logistFullButton.buttons.tenderToDelivery')}
        </a>
        <CreateDeliveryModal
          isShow={showTenderToDeliveryModal}
          setIsShow={setShowTenderToDeliveryModal}
          deliveryId={delivery.Id}
          tenderToDelivery={true}
        />
      </>
    );
  }

  if (isCanRefuse) {
    btnRefuseDelivery = (
      <>
        <a className="action-button typical-btn-red" onClick={onCLickShowRefuseModal}>
          {i18n.t('components.tools.logistFullButton.buttons.refuse')}
        </a>
        <ModalRefuseDelivery
          isShow={showRefuseDeliveryModal}
          setIsShow={setShowRefuseDeliveryModal}
          deliveryId={delivery.Id}
          setLoadingDelivItem={setLoadingDelivItem}
          setNeedUpdate={setNeedUpdate}
          setStopListUpdate={setStopListUpdate}
        />
      </>
    );
  }

  const onClickCancelReservedDelivery = (e) => {
    e.preventDefault();
    setLoadingDelivItem(true);

    deliveriesService
      .cancelReservationDelivery(delivery.Id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.cancelReservationDelivery'),
          description: response.message,
        });

        setLoadingDelivItem(false);
        setNeedUpdate(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.cancelReservationDelivery'),
          description: error,
        });

        setLoadingDelivItem(false);
      });
  };

  const onClickReservedDelivery = (e) => {
    e.preventDefault();
    setLoadingDelivItem(true);

    deliveriesService
      .reserveDelivery(delivery.Id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.reserveDelivery'),
          description: response.message,
        });

        setLoadingDelivItem(false);
        setNeedUpdate(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.reserveDelivery'),
          description: error,
        });

        setLoadingDelivItem(false);
      });
  };

  if (delivery.Permissions.IsAvailableReservation) {
    btnReservation = (
      <a className="action-button typical-btn-blue" onClick={onClickReservedDelivery}>
        <span className="speedometer">{i18n.t('components.tools.logistFullButton.buttons.reserve')}</span>
      </a>
    );
  }

  if (delivery.Status === DELIVERY_RESERVED) {
    btnCancelReserve = (
      <a className="action-button typical-btn-blue" onClick={onClickCancelReservedDelivery}>
        {i18n.t('components.tools.logistFullButton.buttons.cancelReserve')}
      </a>
    );
  }

  if ((delivery.Order && (delivery.Order.Status === DELIVERY_ORDER_APPROVED || delivery.Order.Status === DELIVERY_ORDER_FILLED) && delivery.Status === DELIVERY_BOOKED) || (delivery.Status === DELIVERY_LOADING || delivery.Status === DELIVERY_AWAITING_LOADING)) {
    btnChangeDateLoading = (<>
        <button className={`action-button typical-btn-red`} onClick={() => setShowChangeLoadingDateModal(true)}
        >
          {i18n.t('components.tools.logistFullButton.buttons.changeLoadingDate')}
        </button>
        <ModalChangeLoadingDate id={delivery.Order.Id} isShow={showChangeLoadingDateModal} onCloseModal={setShowChangeLoadingDateModal} date={delivery.LoadingSign? delivery.LoadingSign.DateTime : delivery.Order? moment(delivery.Order.Date).format('DD.MM.YYYY') : ""}/>
      </>
    )
  }

  // Кнопка редактирования рейса доступна только для статусов "В поиске" и "В резерве"
  let btnEditDelivery = null;
  if (delivery.Status === DELIVERY_FREE || delivery.Status === DELIVERY_RESERVED || delivery.Status === DELIVERY_IN_TENDER) {
    btnEditDelivery = (
      <>
        <a className="action-button typical-btn-blue" onClick={() => setShowEditDeliveryModal(true)}>
          {i18n.t('components.tools.logistFullButton.buttons.editDelivery')}
        </a>
        <ModalEditDelivery
          isShow={showEditDeliveryModal}
          delivery={delivery}
          onCloseModal={() => setShowEditDeliveryModal(false)}
          setNeedUpdate={setNeedUpdate}
        />
      </>
    );
  }

  return (
    <div className="ens">
      {btnReservation}
      {btnCancelReserve}
      {btnDeliveryHistory}
      {btnEditDelivery}
      {btnCreateAnalogueDelivery}
      {btnRefuseDelivery}
      {btnChangeDateLoading}
    </div>
  );
}
